import { DELETE_ACCOUNT } from 'constants/ActionTypes';

const deleteAccount = () => ({ type: DELETE_ACCOUNT });

export default deleteAccount;
